import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/services/utils.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ct-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {

  clientId = 1;
  languageId = 1;
  privacy = 'PRIVACY';

  constructor(
    private activatedRoute: ActivatedRoute,
    private utils: UtilsService,
    private translateService: TranslateService

  ) { }

  ngOnInit(): void {
    this.clientId = this.activatedRoute.snapshot.queryParamMap.get('clientId') ? Number(this.activatedRoute.snapshot.queryParamMap.get('clientId')) : 1
    this.languageId = this.activatedRoute.snapshot.queryParamMap.get('languageId') ? Number(this.activatedRoute.snapshot.queryParamMap.get('languageId')) : 1

    if (this.languageId === 96) {
      this.privacy = 'PRIVACYCAT'
    }

    this.translateService.setDefaultLang(this.utils.getLanguageFromLanguageId(this.languageId))
    this.translateService.use(this.utils.getLanguageFromLanguageId(this.languageId))
    document.documentElement.lang = this.utils.getLanguageFromLanguageId(this.languageId).split('-')[0];
  }

}
